import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import redux from '../../redux';

type CustomerServiceManagerProps = {
  customerServiceUrl: string;
};

function CustomerServiceManager({
  customerServiceUrl,
}: CustomerServiceManagerProps) {
  const dispatch: typeof redux.store.dispatch = useDispatch();

  const handleRequestTopLevelCustomer = () => {
    // Handle the request to top-level customer
    dispatch(redux.api.requestTopLevelCustomer());
  };

  useEffect(() => {
    window.addEventListener(
      'context.requestTopLevelCustomer',
      handleRequestTopLevelCustomer,
    );

    return () => {
      window.removeEventListener(
        'context.requestTopLevelCustomer',
        handleRequestTopLevelCustomer,
      );
    };
  });

  useEffect(() => {
    if (customerServiceUrl) {
      dispatch(redux.api.setCustomerServiceUrl(customerServiceUrl));
      dispatch(redux.api.getData());
    }
  }, [customerServiceUrl]);

  return null;
}

export default CustomerServiceManager;
